/** Datagrid key base — full key is `${EMPLOYEES_DATAGRID_KEY}_${organizationId}` */
export const EMPLOYEES_DATAGRID_KEY = "employees_grid";
